import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";

import MarketingLayout from "@/pages/marketing/MarketingLayout";
import Home from "@/pages/marketing/Home";
import MainEvent from "@/pages/marketing/MainEvent";
import { MiniSalons, MiniSalonDetail } from "@/pages/marketing/MiniSalons";
import Exhibitors from "@/pages/marketing/Exhibitors";
import ExhibitRide from "@/pages/marketing/ExhibitRide";
import Sponsors from "@/pages/marketing/Sponsors";
import Judges from "@/pages/marketing/Judges";
import Gallery from "@/pages/marketing/Gallery";
import { News, Contact } from "@/pages/marketing/NewsContact";

import AppLayout from "@/pages/app/AppLayout";
import AppHome from "@/pages/app/AppHome";
import Cars from "@/pages/app/Cars";
import CarDetail from "@/pages/app/CarDetail";
import Leaderboard from "@/pages/app/Leaderboard";
import MapPage from "@/pages/app/MapPage";
import Tickets from "@/pages/app/Tickets";
import { RegisterCar, MyEntries, Favourites } from "@/pages/app/Exhibitor";
import JudgeRunSheet from "@/pages/app/JudgeRunSheet";

import Admin from "@/pages/admin/Admin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/main-event" element={<MainEvent />} />
        <Route path="/mini-salons" element={<MiniSalons />} />
        <Route path="/mini-salons/:slug" element={<MiniSalonDetail />} />
        <Route path="/exhibitors" element={<Exhibitors />} />
        <Route path="/exhibit" element={<ExhibitRide />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route path="/judges" element={<Judges />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
      </Route>

      <Route path="/app" element={<AppLayout />}>
        <Route index element={<AppHome />} />
        <Route path="cars" element={<Cars />} />
        <Route path="cars/:id" element={<CarDetail />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="map" element={<MapPage />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="register-car" element={<RegisterCar />} />
        <Route path="my-entries" element={<MyEntries />} />
        <Route path="favourites" element={<Favourites />} />
        <Route path="judge" element={<JudgeRunSheet />} />
      </Route>

      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
